import { useRequestPasswordReset } from '@/domain/auth';

import { ResetPasswordRequest } from './ResetPasswordRequest';

export function ResetPasswordRequestContainer() {
    const newPasswordRequest = useRequestPasswordReset();
    return <ResetPasswordRequest newPasswordRequest={({ email }) => newPasswordRequest(email)} />;
}
